import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "value", "position", "className", "menu", "onItemClick", "onMenuClick", "onMenuButtonClick", "itemGetters", "menuGetters", "menuAttributes", "closeMenuOnScroll", "buttonScrollThrough"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
import { composePreparedProps } from "./utils";
import { TabBarNav } from "./TabBarNav";
import { TabBarMenu } from "./TabBarMenu";
var cnTabBar = cnBem('tabbar', styles);
var TabBarRender = function TabBarRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    _composePreparedProps2 = _composePreparedProps.items,
    items = _composePreparedProps2 === void 0 ? [] : _composePreparedProps2,
    value = _composePreparedProps.value,
    _composePreparedProps3 = _composePreparedProps.position,
    position = _composePreparedProps3 === void 0 ? 'default' : _composePreparedProps3,
    className = _composePreparedProps.className,
    menu = _composePreparedProps.menu,
    onItemClick = _composePreparedProps.onItemClick,
    onMenuClick = _composePreparedProps.onMenuClick,
    onMenuButtonClick = _composePreparedProps.onMenuButtonClick,
    itemGetters = _composePreparedProps.itemGetters,
    menuGetters = _composePreparedProps.menuGetters,
    menuAttributes = _composePreparedProps.menuAttributes,
    closeMenuOnScroll = _composePreparedProps.closeMenuOnScroll,
    buttonScrollThrough = _composePreparedProps.buttonScrollThrough,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnTabBar({
      position: position
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "components-TabBar"
  }), /*#__PURE__*/React.createElement(TabBarMenu, _extends({}, menuGetters, menuAttributes || {}, {
    className: cnTabBar('button'),
    closeMenuOnScroll: closeMenuOnScroll,
    items: menu,
    onMenuButtonClick: onMenuButtonClick,
    onMenuClick: onMenuClick,
    position: position
  })), /*#__PURE__*/React.createElement(TabBarNav, _extends({}, itemGetters, {
    buttonScrollThrough: buttonScrollThrough,
    className: cnTabBar('wrapper', {
      position: position
    }),
    items: items,
    onItemClick: onItemClick,
    position: position,
    value: value
  })));
};
export var TabBar = /*#__PURE__*/forwardRef(TabBarRender);